<template>

  <head>

    <meta charset="utf-8" />
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">


    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->




    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">E Construction Analytics</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    <li class="breadcrumb-item active">E Construction</li>
                    <li class="breadcrumb-item active">Analytics</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->
          <div class="row">
            <div class="col-lg-12 px-sm-30px">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-12 align-self-center text-capitalize">
                      <div class="text-lg-left mt-4 mt-lg-0">
                        <div class="row">
                          <!-- Pending Applications -->
                          <div class="col-sm-6 col-md-2 col-lg-2 mb-5 mb-md-0">
                            <div>
                              <div class="avatar-xs mb-3">
                                                                <span class="avatar-title rounded-circle bg-warning font-size-16">
                                                                    <i class="mdi mdi-clock-outline text-white"></i>
                                                                </span>
                              </div>
                              <p class="text-muted text-truncate mb-2">Pending Applications</p>
                              <h5 class="mb-0">1,500</h5>
                            </div>
                          </div>

                          <!-- Approved Applications -->
                          <div class="col-sm-6 col-md-2 col-lg-2 mb-5 mb-md-0">
                            <div>
                              <div class="avatar-xs mb-3">
                                                                <span class="avatar-title rounded-circle bg-success font-size-16">
                                                                    <i class="mdi mdi-check-circle-outline text-white"></i>
                                                                </span>
                              </div>
                              <p class="text-muted text-truncate mb-2">Approved Applications</p>
                              <h5 class="mb-0">1,320</h5>
                            </div>
                          </div>

                          <!-- Rejected Applications -->
                          <div class="col-sm-12 col-md-2 col-lg-2 mb-5 mb-md-0">
                            <div>
                              <div class="avatar-xs mb-3">
                                                                <span class="avatar-title rounded-circle bg-danger font-size-16">
                                                                    <i class="mdi mdi-close-circle-outline text-white"></i>
                                                                </span>
                              </div>
                              <p class="text-muted text-truncate mb-2">Rejected Applications</p>
                              <h5 class="mb-0">180</h5>
                            </div>
                          </div>

                          <!-- Total Personnel -->
                          <div class="col-sm-12 col-md-2 col-lg-2 mb-5 mb-md-0">
                            <div>
                              <div class="avatar-xs mb-3">
                                                                <span class="avatar-title rounded-circle bg-info font-size-16">
                                                                    <i class="mdi mdi-account-group text-white"></i>
                                                                </span>
                              </div>
                              <p class="text-muted text-truncate mb-2">Total Personnel</p>
                              <h5 class="mb-0">2,000</h5>
                            </div>
                          </div>

                          <!-- New Personnel -->
                          <div class="col-sm-12 col-md-2 col-lg-2 mb-5 mb-md-0">
                            <div>
                              <div class="avatar-xs mb-3">
                                                                <span class="avatar-title rounded-circle bg-primary font-size-16">
                                                                    <i class="mdi mdi-account-plus text-white"></i>
                                                                </span>
                              </div>
                              <p class="text-muted text-truncate mb-2">New Personnel</p>
                              <h5 class="mb-0">48</h5>
                            </div>
                          </div>

                          <!-- Awaiting Approval -->
                          <div class="col-sm-12 col-md-2 col-lg-2 mb-5 mb-md-0">
                            <div>
                              <div class="avatar-xs mb-3">
                                                                <span class="avatar-title rounded-circle bg-pink font-size-16">
                                                                    <i class="mdi mdi-timer-sand text-white"></i>
                                                                </span>
                              </div>
                              <p class="text-muted text-truncate mb-2">Awaiting Approval</p>
                              <h5 class="mb-0">22</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <!-- end row -->
                </div>
              </div>
            </div>
            <div class="col-xl-12 px-sm-30px">
              <div class="row">
                <!-- Pending Bills -->
                <div class="col-lg-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Pending Bills</p>
                          <h5 class="mb-0 fw-bold">KES 1,234,567,890</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div class="avatar-title bg-light rounded-circle text-danger font-size-20">
                            <i class="mdi mdi-cash-alert"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body border-top py-3">
                      <p class="mb-0">From 345 Invoices</p>
                    </div>
                  </div>
                </div>

                <!-- Total Revenue from Approved & Active Applications -->
                <div class="col-lg-3 ">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Revenue collected this Month</p>
                          <h5 class="mb-0 fw-bold">KES 5,678,900,123</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div class="avatar-title bg-light rounded-circle text-success font-size-20">
                            <i class="mdi mdi-bank"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body border-top py-3">
                      <p class="mb-0">Includes active permits and ongoing projects</p>
                    </div>
                  </div>
                </div>

                <!-- Revenue Collected for Current Financial Year -->
                <div class="col-lg-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Revenue Collected (Financial Year)</p>
                          <h5 class="mb-0 fw-bold">KES 3,456,789,012</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                            <i class="mdi mdi-calendar"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body border-top py-3">
                      <p class="mb-0">From July 2024 to present</p>
                    </div>
                  </div>
                </div>

                <!-- Revenue Collected for Current Week -->
                <div class="col-lg-3">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex flex-wrap">
                        <div class="me-3">
                          <p class="text-muted mb-2">Revenue Collected (This Week)</p>
                          <h5 class="mb-0 fw-bold">KES 789,012,345</h5>
                        </div>
                        <div class="avatar-sm ms-auto">
                          <div class="avatar-title bg-light rounded-circle text-info font-size-20">
                            <i class="mdi mdi-calendar-week"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body border-top py-3">
                      <p class="mb-0">Updated as of today</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-sm-12 col-md-6 px-sm-30px">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="d-sm-flex flex-wrap">
                    <h4 class="card-title mb-4">Important Statistics</h4>
                    <div class="ms-auto">
                      <a href="javascript:void(0);" class="btn btn-primary"><i class="bx bx-plus align-middle"></i> Download</a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div>
                    <div class="table-responsive font-12" style="height: 450px; overflow-y: auto;">
                      <table class="table table-striped table-sm font-12 verticle-middle">
                        <thead class="table-dark">
                        <tr class="font-weight-bold">
                          <th scope="col" rowspan="2">Sub County</th>
                          <th colspan="2">Identified Businesses</th>
                          <th class="text-right" colspan="2">Fire Certification Invoices</th>
                        </tr>
                        <tr>
                          <th>SBPs</th>
                          <th>Fire Certified Businesses</th>
                          <th class="text-right">Pending</th>
                          <th class="text-right">Paid</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>RACHUONYO NORTH</td>
                          <td>32</td>
                          <td>12</td>
                          <td class="table-danger text-right">30 <span class="fw-bold text-dark">(8,500)</span></td>
                          <td class="table-success text-right">50 <span class="fw-bold text-dark">(15,000)</span></td>
                        </tr>
                        <tr>
                          <td>RACHUONYO EAST</td>
                          <td>27</td>
                          <td>8</td>
                          <td class="table-danger text-right">20 <span class="fw-bold text-dark">(6,000)</span></td>
                          <td class="table-success text-right">40 <span class="fw-bold text-dark">(10,000)</span></td>
                        </tr>
                        <tr>
                          <td>RACHUONYO SOUTH</td>
                          <td>50</td>
                          <td>20</td>
                          <td class="table-danger text-right">25 <span class="fw-bold text-dark">(7,000)</span></td>
                          <td class="table-success text-right">55 <span class="fw-bold text-dark">(14,000)</span></td>
                        </tr>
                        <tr>
                          <td>SUBA NORTH</td>
                          <td>38</td>
                          <td>15</td>
                          <td class="table-danger text-right">40 <span class="fw-bold text-dark">(12,500)</span></td>
                          <td class="table-success text-right">35 <span class="fw-bold text-dark">(9,000)</span></td>
                        </tr>
                        <tr>
                          <td>RANGWE</td>
                          <td>42</td>
                          <td>18</td>
                          <td class="table-danger text-right">28 <span class="fw-bold text-dark">(9,000)</span></td>
                          <td class="table-success text-right">60 <span class="fw-bold text-dark">(18,000)</span></td>
                        </tr>
                        <tr>
                          <td>HOMA BAY TOWN</td>
                          <td>55</td>
                          <td>25</td>
                          <td class="table-danger text-right">35 <span class="fw-bold text-dark">(10,500)</span></td>
                          <td class="table-success text-right">75 <span class="fw-bold text-dark">(20,000)</span></td>
                        </tr>
                        <tr>
                          <td>NDHIWA</td>
                          <td>60</td>
                          <td>30</td>
                          <td class="table-danger text-right">50 <span class="fw-bold text-dark">(15,000)</span></td>
                          <td class="table-success text-right">65 <span class="fw-bold text-dark">(17,000)</span></td>
                        </tr>
                        <tr>
                          <td>SUBA SOUTH</td>
                          <td>47</td>
                          <td>22</td>
                          <td class="table-danger text-right">33 <span class="fw-bold text-dark">(11,000)</span></td>
                          <td class="table-success text-right">55 <span class="fw-bold text-dark">(13,500)</span></td>
                        </tr>
                        <tr>
                          <td>HOMA BAY HQ</td>
                          <td>70</td>
                          <td>35</td>
                          <td class="table-danger text-right">45 <span class="fw-bold text-dark">(14,000)</span></td>
                          <td class="table-success text-right">80 <span class="fw-bold text-dark">(22,000)</span></td>
                        </tr>
                        <tr class="table-dark">
                          <th>Total</th>
                          <th>421</th>
                          <th>185</th>
                          <td class="text-danger text-right">306 <span class="fw-bold">(KES 93,500)</span></td>
                          <td class="text-success text-right">515 <span class="fw-bold">(KES 138,500)</span></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="col-sm-12 col-md-6 px-sm-30px">
              <div class="card">

                <div class="card-header d-flex justify-content-between bg-white border-bottom">
                  <div>
                    <h4 class="card-title text-uppercase">Revenue Perfomance</h4>
                    <p class="">All Sub Counties</p>
                  </div>
                  <div class="">
                    <div class="float-end d-flex">
                      <div class="input-group input-group-sm">
                        <select class="form-select form-select-sm">
                          <option value="All Sub Counties" selected>All Sub counties</option>
                          <option value="RACHUONYO NORTH">Rachuonyo North</option>
                          <option value="RACHUONYO EAST">Rachuonyo East</option>
                          <option value="RACHUONYO SOUTH">Rachuonyo South</option>
                          <option value="SUBA NORTH">Suba North</option>
                          <option value="RANGWE">Rangwe</option>
                          <option value="HOMA BAY TOWN">Homa Bay Town</option>
                          <option value="NDHIWA">Ndhiwa</option>
                          <option value="SUBA SOUTH">Suba South</option>
                          <option value="HOMA BAY HQ">Homa Bay HQ</option>
                        </select>
                        <label class="input-group-text">Sub County</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">

                  <div id="containerRev"></div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->


      <!-- bootstrap modal -->
      <div class="modal fade" id="changeStream" tabindex="-1" role="dialog"
           aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Change Revenue Stream</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div>
                    <label class="form-label">Select New Revenue Stream</label>
                    <select class="form-control selectpicker bg-white" title="Select Revenue Stream"
                            data-live-search="true">
                      <option value=" ">Failing to carry and produce a driving license on demand.
                      </option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        1-5 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        6-10 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        11-15 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        16-20 KPH</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary w-100 text-center">Save changes</button>
            </div>
          </div>
        </div>
      </div>
      <!-- end of changing revenue stream modal -->

      <!-- modal for details -->
      <div class="modal fade construction-permit-modal" tabindex="-1" role="dialog" aria-labelledby="constructionPermitModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="constructionPermitModalLabel">Construction Permit Application</h5>
              <span class="badge rounded-pill bg-primary text-uppercase mx-3">In Progress</span>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Professional Person Details Section -->
              <div class="col-12 mt-4">
                <div class="bg-dark border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                  <i class="bx bx-user-circle font-28 mr-15px"></i>
                  <p class="fw-semibold mb-0 pb-0">Professional Person Details</p>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                    <tbody>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Full Names</p></td>
                      <td>John Doe Architectural Consultants</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Phone Number</p></td>
                      <td>+254 712 345 678</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Email Address</p></td>
                      <td>john.doe@architecturalconsultants.com</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Professional Type</p></td>
                      <td>Architect</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Governing Body</p></td>
                      <td>Architectural Association of Kenya</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Certificate Number</p></td>
                      <td>AAK/2023/1234</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Certificate Expiration</p></td>
                      <td>31 December 2024</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">National ID Number</p></td>
                      <td>12345678</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Application Details Section -->
              <div class="col-12 mt-4">
                <div class="bg-info border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                  <i class="bx bx-detail font-28 mr-15px"></i>
                  <p class="fw-semibold mb-0 pb-0">Application Details</p>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                    <tbody>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Application Date</p></td>
                      <td>15 March 2025</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Application/Tracking Number</p></td>
                      <td>CP-HB-2025-0001</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Project Name</p></td>
                      <td>Homa Bay Commercial Complex</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Development Type</p></td>
                      <td>New Building Construction</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Sub County</p></td>
                      <td>Homa Bay</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Ward</p></td>
                      <td>Homa Bay Central</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Plot Number</p></td>
                      <td>LR NO. 1224/890</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Project Value</p></td>
                      <td>KES 50,000,000</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Project Duration</p></td>
                      <td>12 Months</td>
                    </tr>
                    <tr>
                      <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Project Description</p></td>
                      <td>Multi-story commercial building with retail and office spaces</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Supporting Documents Section -->
              <div class="col-12 mt-4">
                <div class="bg-warning border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                  <i class="bx bx-file font-28 mr-15px"></i>
                  <p class="fw-semibold mb-0 pb-0">Supporting Documents</p>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                    <tbody>
                    <tr><td>Land Ownership Documents (LO-2025-0001)</td><td><a href="path/to/land-ownership-doc.pdf" target="_blank">📄 View</a></td></tr>
                    <tr><td>Consent Letter (CL-2025-0002)</td><td><a href="path/to/consent-letter.pdf" target="_blank">📄 View</a></td></tr>
                    <tr><td>Architectural Drawings (AD-2025-0003)</td><td><a href="path/to/architectural-drawings.pdf" target="_blank">📄 View</a></td></tr>
                    <tr><td>Structural Engineering Plans (SP-2025-0004)</td><td><a href="path/to/structural-plans.pdf" target="_blank">📄 View</a></td></tr>
                    <tr><td>Owner's ID Number (ID-2025-0005)</td><td>12345678</td></tr>
                    <tr><td>Owner's KRA PIN Number (KRA-2025-0006)</td><td>A123456789B</td></tr>
                    <tr><td>Land Search Certificate Number (LS-2025-0007)</td><td><a href="path/to/land-search-cert.pdf" target="_blank">📄 View</a></td></tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Initial Billing Information -->
              <div class="col-12 mt-4">
                <div class="bg-success border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                  <i class="bx bx-receipt font-28 mr-15px"></i>
                  <p class="fw-semibold mb-0 pb-0">Initial Billing Information</p>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                    <tbody>
                    <tr><td>Land Rate Arrears</td><td>KES 25,000</td></tr>
                    <tr><td>Application Fees</td><td>KES 5,000</td></tr>
                    <tr><td>Form Fees</td><td>KES 1,000</td></tr>
                    <tr><td>Payment Method</td><td>M-PESA</td></tr>
                    <tr><td>Reference Number</td><td>MPESA8790JKL</td></tr>
                    <tr><td>Invoice Number</td><td>INV-CP-2025-0001</td></tr>
                    <tr><td>Receipt Number</td><td>RCP-CP-2025-0001</td></tr>
                    <tr><td>Amount Invoiced</td><td>KES 31,000</td></tr>
                    <tr><td>Amount Paid</td><td>KES 31,000</td></tr>
                    <tr><td>Pending Amount</td><td>KES 0</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Final Billing Information -->
              <div class="col-12 mt-4">
                <div class="bg-primary border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                  <i class="bx bx-dollar-circle font-28 mr-15px"></i>
                  <p class="fw-semibold mb-0 pb-0">Final Billing Information</p>
                </div>
                <div class="row">
                  <div class="table-responsive mb-4">
                    <table class="table table-editable-1 align-middle table-edits">
                      <thead class="table-light">
                      <tr class="text-uppercase table-dark">
                        <th>#</th>
                        <th>Service Type</th>
                        <th class="">Fee Item</th>
                        <th class="">QTY</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr data-id="7">
                        <td style="width: 80px">7.</td>
                        <td>
                          <select class="form-select">
                            <option>Inspection Fee</option>
                            <option>Approval Fee</option>
                            <option>Additional Charges</option>
                          </select>
                        </td>
                        <td>
                          <select class="form-select">
                            <option>Plan Review</option>
                            <option>Site Inspection</option>
                            <option>Final Approval</option>
                          </select>
                        </td>
                        <td><input type="text" class="form-control" placeholder="QTY" spellcheck="false"></td>
                        <td></td>
                      </tr>

                      <tr class="cloneCharges d-none">
                        <td style="width: 80px" class="categoryIndex">#</td>
                        <td>
                          <select class="form-select">
                            <option>Inspection Fee</option>
                            <option>Approval Fee</option>
                            <option>Additional Charges</option>
                          </select>
                        </td>
                        <td>
                          <select class="form-select">
                            <option>Plan Review</option>
                            <option>Site Inspection</option>
                            <option>Final Approval</option>
                          </select>
                        </td>
                        <td><input type="text" class="form-control" placeholder="QTY" spellcheck="false"></td>
                        <td class="text-right cell-change d-flex align-items-center justify-content-end">
                          <a class="btn btn-light btn-rounded waves-effect btn-circle btn-transparent cancel-new-category-2" title="Cancel"><i class="bx bx-x"></i></a>
                        </td>
                      </tr>
                      </tbody>

                      <tfoot>
                      <tr>
                        <td colspan="7" class="bg-light add-field-1 cursor-pointer">
                                                        <span class="d-flex align-items-center">
                                                            <i class="dripicons-plus mr-5 d-flex justify-content-center align-items-center font-21"></i>
                                                            <span class="pl-5">Upload Other Documents</span>
                                                        </span>
                        </td>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- trial -->

                  </div>

                  <div class="form-group">
                    <label for="approval-comments-1">Approval
                      Comments</label>
                    <textarea class="form-control" id="approval-comments-1"
                              rows="3"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save Changes</button>
            </div>
          </div>
        </div>
      </div>
      <!-- end of details modal -->


      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>

    <!-- end main content-->



  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>

</template>

<script>
/* eslint-disable */
import Highcharts from 'highcharts';


// Load modules directly via import - no initialization needed
import 'highcharts/modules/drilldown';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/gantt';


// Set default global options for Highcharts to use a safe locale
Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
    decimalPoint: '.'
  }
});



import NavigationBar from "@/components/Navigation";

export default {
  name: "eConstructionStats",
  components: { NavigationBar},
  data() {
    return {

    }

  },
  watch: {
  },

  mounted() {


  },
  methods: {
    fgggg(){
      Highcharts.chart('containerRev', {
        chart: {
          zoomType: 'xy'
        },
        title: {
          text: 'Building Permits Revenue and Approved Applications (Yearly)'
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          crosshair: true
        },
        yAxis: [{
          title: {
            text: 'Revenue (KES)',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          labels: {
            format: '{value} M',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          }
        }, {
          title: {
            text: 'Approved Applications',
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'top',
          x: 80,
          y: 55,
          floating: true,
          backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || 'rgba(255,255,255,0.25)'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [12.5, 15.2, 18.3, 14.4, 16.1, 20.7, 22.0, 19.8, 17.5, 21.3, 23.1, 25.7],
          tooltip: {
            valueSuffix: ' M KES'
          }
        }, {
          name: 'Approved Applications',
          type: 'spline',
          yAxis: 1,
          data: [102, 95, 110, 120, 130, 150, 170, 165, 140, 155, 160, 175],
          tooltip: {
            valueSuffix: ' Applications'
          }
        }]
      });
    }
  },
  computed:{

  }
}
</script>


<style scoped>

</style>